import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.events.grayShade2,
    color: theme.palette.text.primary,
    borderRadius: "5px",
    border: `1px solid ${theme.palette.events.grayShade1}`,
    boxShadow: "0px 4px 4px #0C38911A",
    width: "100%",
    padding: `${theme.spacing(2.5)} ${theme.spacing(5)}`,
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  textContainer: {
    width: "auto",
  },
  title: {
    marginBottom: "5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  subtitle: {
    fontSize: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  createFirstEventButton: {
    marginTop: theme.spacing(-2),
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(0.5),
    },
  },
  supportContainer: {
    marginTop: theme.spacing(2),
  },
  supportTitle: {
    display: "flex",
    alignItems: "center",
  },
  supportIcon: {
    marginRight: theme.spacing(1),
  },
  supportSubtitle: {
    fontSize: "14px",
    marginTop: "2px",
  },
  grid: {
    gap: "100px",
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      marginTop: theme.spacing(1),
      flexDirection: "column-reverse",
    },
  },
  buttonGrid: {
    display: "grid",
    paddingTop: theme.spacing(1),
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
      alignContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
  liveSupportLoungeButton: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("lg")]: {
      marginTop: "unset",
      marginLeft: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginLeft: "unset",
    },
  },
  linkIcon: {
    marginLeft: theme.spacing(0.5),
    height: "0.8em",
    marginRight: theme.spacing(0.5),
  },
  linkText: {
    textDecoration: "none",
    height: "38px",
  },
  support: {
    maxWidth: "190px",
  },
  helpDesk: {
    maxWidth: "178px",
  },
  linkGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  divider: {
    color: theme.palette.events.grayShade1,
  },
}));
